import { Container } from "@mantine/core";
import { ViewTransition } from "react";
import { Outlet, useLocation } from "react-router-dom";
import styles from "./styles/Layout.module.css";
import { Footer } from "./Footer";

export const Layout = () => {
    const { pathname } = useLocation();

    return (
        <>
            <div className={"main " + styles.main}>
                <Container size="lg">
                    {/* Keyed by path so each page enters/exits as its own view transition */}
                    <ViewTransition key={pathname} enter="page-enter" exit="page-exit" default="none">
                        <Outlet />
                    </ViewTransition>
                </Container>
            </div>
            <Footer />
        </>
    );
};
